export default "__VITE_ASSET__UgAKrgXg__"